import React from 'react';
import { motion } from 'framer-motion';
import Container from '../../layout/Container';
import Button from '../../common/Button';

const CallToAction = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-blue-600 to-blue-800 text-white">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Partner with Bytematic for Your IT Success
            </h2>
            
            <p className="text-lg text-blue-100 mb-8">
              Let us help you build a robust IT infrastructure that powers your business growth.
              Contact us today to discuss your needs and discover how we can help.
            </p>
            
            <div className="flex flex-wrap justify-center gap-4">
              <Button 
                to="/contact" 
                variant="secondary"
                size="lg"
                className="text-blue-700 hover:bg-green-500 hover:text-white"
              >
                Get in Touch
              </Button>
              
              <Button 
                to="/solutions" 
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:bg-opacity-10"
              >
                Explore Solutions
              </Button>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  );
};

export default CallToAction;